import React, { useEffect } from "react";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "PrivacyPolicy/StudioMK";
  }, []);

  return (
    <div className={styles.privacypolicy}>
      <h1>プライバシーポリシー</h1>

      <p>
        StudioMK（以下、「当サービス」）は、お客様のプライバシーを尊重し、お客様が提供された個人情報を保護することを重視しています。このプライバシーポリシーは、当サービスが収集する情報とその情報の利用について説明します。当ポリシーに記載されている内容にご同意いただけない場合は、当サービスの利用をお控えください。
      </p>

      <h2>1. 収集される情報</h2>

      <p>
        当サービスは、お客様が当サービスを利用する際に提供される情報を収集する場合があります。これには、お名前、連絡先情報、メールアドレス、その他の個人情報が含まれます。また、Cookieや同様の技術を使用して、お客様のブラウザやデバイスから情報を収集する場合があります。
      </p>

      <h2>2. 情報の利用</h2>

      <p>当サービスは、収集した情報を以下の目的で利用することがあります。</p>
      <ul>
        <li>サービスの提供、運営、維持管理</li>
        <li>お客様に関連する情報やサービスの提供</li>
        <li>サービスの改善やカスタマイズ</li>
        <li>サービスのセキュリティ確保</li>
        <li>法的義務の遵守</li>
      </ul>

      <h2>3. 情報の共有</h2>

      <p>
        当サービスは、お客様の個人情報を以下の条件で第三者と共有する場合があります。
      </p>
      <ul>
        <li>お客様の同意がある場合</li>
        <li>法的要求に応じる必要がある場合</li>
        <li>サービス提供に必要な場合</li>
      </ul>

      <h2>4. データの保護</h2>

      <p>
        当サービスは、お客様の個人情報を適切に保護するために技術的、物理的、組織的な安全対策を実施します。
      </p>

      <h2>5. お問い合わせ先</h2>

      <p>
        プライバシーポリシーに関するご質問やお問い合わせがある場合は、以下の連絡先までご連絡ください。
      </p>
      <p>StudioMK https://forms.gle/VWaaBkT6v47mPtXk9</p>

      <p>
        このプライバシーポリシーは、変更される場合があります。最新の情報をご確認いただくために、定期的にご確認ください。
      </p>
    </div>
  );
};

export default PrivacyPolicy;
